import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FullSizeColumn } from '../../../Components/FlexBox';
import FormTextField from '../../../Components/Form/FormTextField';

const DraftPracticeForm = function DraftPracticeForm() {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <FullSizeColumn padding="8px">
      <FormTextField
        required
        name="practiceNumber"
        error={errors?.practiceNumber}
      />
    </FullSizeColumn>
  );
};

export default DraftPracticeForm;
